import { z } from "zod";

const provideAiFeedbackInputSchema = z.object({
  scores: z.record(z.number()),
  projectName: z.string(),
  spanId: z.string(),
  comment: z.string().optional(),
});

const provideAiFeedbackOutputSchema = z.object({ success: z.boolean() });

export type ProvideAiFeedbackInput = z.infer<
  typeof provideAiFeedbackInputSchema
>;
export type ProvideAiFeedbackOutput = z.infer<
  typeof provideAiFeedbackOutputSchema
>;

export const provideAiFeedback = {
  input: provideAiFeedbackInputSchema,
  output: provideAiFeedbackOutputSchema,
};
